import React from 'react';
import { Icon, Button } from '@eriksdigital/atomic-ui/components';
import {
  EditIcon,
  LoadingIcon,
} from '@eriksdigital/atomic-ui/components/Icons';

import { translationString } from 'locales/translation';

interface Props {
  resourceId: string;
  loading?: boolean;
  onClick: Function;
}

export const UpdateResourceButton = ({
  resourceId,
  loading = false,
  onClick,
}: Props) => {
  return (
    <Button
      id={`${resourceId}_edit_button`}
      onClick={onClick}
      size="regular"
      stretch="auto"
      variant="square"
      weight="medium"
      type="button"
      isLoading={loading}
      data-stringid="Edit"
      aria-label={translationString('Edit')}
    >
      <Icon as={loading ? LoadingIcon : EditIcon} size="sz32" />
    </Button>
  );
};
